"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavbarMenu = exports.NavbarMenuList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const react_uid_1 = require("react-uid");
const NavbarMenuList = ({ menuGroups, }) => {
    const seed = react_uid_1.useUIDSeed();
    const MenuGroups = menuGroups.map((menuGroup, index) => (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [jsx_runtime_1.jsx(react_2.MenuGroup, Object.assign({ title: menuGroup.title }, { children: menuGroup.menuItems.map(({ label, onClick }) => (jsx_runtime_1.jsx(react_2.MenuItem, Object.assign({ onClick: onClick }, { children: label }), label))) }), menuGroup.title),
            index < menuGroups.length - 1 ? jsx_runtime_1.jsx(react_2.MenuDivider, {}, void 0) : null] }, seed(menuGroup))));
    return jsx_runtime_1.jsx(react_2.MenuList, { children: MenuGroups }, void 0);
};
exports.NavbarMenuList = NavbarMenuList;
const NavbarMenu = ({ menuConfig, }) => {
    if (!menuConfig)
        return null;
    const { name, menuGroups, avatarSrc } = menuConfig;
    const userAvatar = avatarSrc || 'https://bit.ly/broken-link';
    return (jsx_runtime_1.jsxs(react_2.Menu, { children: [jsx_runtime_1.jsx(react_2.MenuButton, Object.assign({ "data-testid": "navbar.user-menu" }, { children: jsx_runtime_1.jsx(react_2.Avatar, { size: "sm", name: name, src: userAvatar }, void 0) }), void 0),
            jsx_runtime_1.jsx(exports.NavbarMenuList, { menuGroups: menuGroups }, void 0)] }, void 0));
};
exports.NavbarMenu = NavbarMenu;
exports.default = exports.NavbarMenu;
